export const PAGE_CONFIG = {
  "title": "WOW核心数据看板",
  "titleCN": "WOW核心数据看板",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/wow/index",
  "defaultTab": "wow",
  "tabList": [
    {
      "id": "wow",
      "tabName": "WOW",
      "tabNameCN": "WOW",
      "isHaveNotification": true,
      "notificationPath": "/wow/index",
      "path": "/wow/index",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "205601",
        "pageName": "wowIndex",
        "extInfo": "wowIndex",
        "pagePath": "/wow/index"
      },
      "filters": [
        {
          "name": "WowFIlter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/wow/index",
          "selectorListApi": "/api/v1/dashboard/wow_selector",
          "data": {
            "metric": "wow_map_cnt"
          },
          "componentList": [
            {
              "name": "KeyMetricsCo",
              "className": "dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "isChangeHeight": 340,
                  "api": "/api/v1/dashboard/wow/card_metrics",
                  "mainMetricsList": [
                    "wow_user_num",
                    "wow_user_num_rate",
                    "wow_new_user",
                    "wow_player_d2t1",
                    "wow_cnt_role",
                    "wow_map_cnt_accum"
                  ],
                  "metricsList": [
                    "wow_user_num",
                    "wow_user_num_rate",
                    "wow_new_user",
                    "wow_player_d2t1",
                    "wow_cnt_role",
                    "wow_map_cnt_accum"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "wow_user_num",
                                  "enName": "日活跃",
                                  "cnName": "日活跃",
                                  "rangeEnName": "平均日活跃",
                                  "rangeCnName": "平均日活跃",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pubg wow user num",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-u",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "wow_user_num_rate",
                                  "enName": "参与率",
                                  "cnName": "参与率",
                                  "rangeEnName": "参与率",
                                  "rangeCnName": "参与率",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pubg wow cnt role rate",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "pie-chart-icon",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "wow_new_user",
                                  "enName": "模式新增用户",
                                  "cnName": "模式新增用户",
                                  "rangeEnName": "模式新增用户",
                                  "rangeCnName": "模式新增用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pubg wow new user",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-plus",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "wow_player_d2t1",
                                  "enName": "游玩次留(T-1)",
                                  "cnName": " 游玩次留(T-1)",
                                  "rangeEnName": "游玩次留(T-1)",
                                  "rangeCnName": "游玩次留(T-1)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pubg wow player d2t1",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "wow_cnt_role",
                                  "enName": "编辑模式参与人数",
                                  "cnName": "编辑模式参与人数",
                                  "rangeEnName": "编辑模式参与人数",
                                  "rangeCnName": "编辑模式参与人数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pubg wow cnt role",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-pcu",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "wow_map_cnt_accum",
                                  "enName": "地图历史总数",
                                  "cnName": "地图历史总数",
                                  "rangeEnName": "地图历史总数",
                                  "rangeCnName": "地图历史总数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pubg wow map cnt accum",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "game",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "margin-t-10",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 12
                  },
                  "children": [
                    {
                      "name": "OverviewMetricsTrendCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "renderIndex": 0,
                          "excelFilterEnName": "游玩指标",
                          "excelFilterCnName": "游玩指标",
                          "showLastMonthYear": true,
                          "showVs": false,
                          "api": {
                            "metricsApi": "/api/v1/dashboard/wow/metrics_trend",
                            "dimensionApi": "/api/v1/dashboard/wow/dimension/metrics_trend",
                            "extraParams": {
                              "show_last_month_year_value": true
                            }
                          },
                          "componentMetrics": [
                            {
                              "enName": "最高同时在线",
                              "cnName": "最高同时在线",
                              "metricKey": "wow_pcu",
                              "rainbowKey": "Pubg wow pcu",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "平均同时在线",
                              "cnName": "平均同时在线",
                              "metricKey": "wow_acu",
                              "rainbowKey": "Pubg wow acu",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "次留",
                              "cnName": "次留",
                              "metricKey": "wow_player_d2",
                              "rainbowKey": "Pubg wow player d2",
                              "type": "percent",
                              "decimal": 2
                            },
                            {
                              "enName": "3留",
                              "cnName": "3留",
                              "metricKey": "wow_player_d3",
                              "rainbowKey": "Pubg wow player d3",
                              "type": "percent",
                              "decimal": 2
                            },
                            {
                              "enName": "7留",
                              "cnName": "7留",
                              "metricKey": "wow_player_d7",
                              "rainbowKey": "Pubg wow player d7",
                              "type": "percent",
                              "decimal": 2
                            },
                            {
                              "enName": "30留",
                              "cnName": "30留",
                              "metricKey": "wow_player_d30",
                              "rainbowKey": "Pubg wow player d30",
                              "type": "percent",
                              "decimal": 2
                            },
                            {
                              "enName": "人均游玩作品数",
                              "cnName": "人均游玩作品数",
                              "metricKey": "wow_avg_play_map_cnt",
                              "rainbowKey": "Pubg wow avg play map cnt",
                              "type": "decimals",
                              "decimal": 2
                            },
                            {
                              "enName": "人均游玩地图次数",
                              "cnName": "人均游玩地图次数",
                              "metricKey": "wow_avg_play_cnt",
                              "rainbowKey": "Pubg wow avg play cnt",
                              "type": "decimals",
                              "decimal": 2
                            },
                            {
                              "enName": "人均游玩时长(分钟)",
                              "cnName": "人均游玩时长(分钟)",
                              "metricKey": "wow_avg_playtime",
                              "rainbowKey": "Pubg wow avg playtime",
                              "type": "decimals",
                              "decimal": 2
                            },
                            {
                              "enName": "日活跃",
                              "cnName": "日活跃",
                              "metricKey": "wow_user_num",
                              "rainbowKey": "Pubg wow user num",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "模式新增用户",
                              "cnName": "模式新增用户",
                              "metricKey": "wow_new_user",
                              "rainbowKey": "Pubg wow new user",
                              "type": "int",
                              "decimal": 0
                            }
                          ]
                        }
                      }
                    }
                  ]
                },
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 12
                  },
                  "children": [
                    {
                      "name": "OverviewMetricsTrendCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "renderIndex": 1,
                          "excelFilterEnName": "创作指标",
                          "excelFilterCnName": "创作指标",
                          "showLastMonthYear": true,
                          "showVs": false,
                          "api": {
                            "metricsApi": "/api/v1/dashboard/wow/metrics_trend",
                            "dimensionApi": "/api/v1/dashboard/wow/dimension/metrics_trend",
                            "extraParams": {
                              "show_last_month_year_value": true
                            }
                          },
                          "componentMetrics": [
                            {
                              "enName": "发布作品数",
                              "cnName": "发布作品数",
                              "metricKey": "wow_release_cnt",
                              "rainbowKey": "Pubg wow release cnt",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "更新作品数",
                              "cnName": "更新作品数",
                              "metricKey": "wow_update_release_cnt",
                              "rainbowKey": "Pubg wow update release cnt",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "编辑模式参与次数",
                              "cnName": "编辑模式参与次数",
                              "metricKey": "wow_ugc_edit_num",
                              "rainbowKey": "Pubg wow ugc edit num",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "参与人数",
                              "cnName": "参与人数",
                              "metricKey": "wow_cnt_role",
                              "rainbowKey": "Pubg wow cnt role",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "参与率",
                              "cnName": "参与率",
                              "metricKey": "wow_cnt_role_rate",
                              "rainbowKey": "Pubg wow cnt role rate",
                              "type": "percent",
                              "decimal": 2
                            },
                            {
                              "enName": "人均编辑时长(分钟)",
                              "cnName": "人均编辑时长(分钟)",
                              "metricKey": "wow_avg_edit_time",
                              "rainbowKey": "Pubg wow avg edit time",
                              "type": "decimals",
                              "decimal": 2
                            },
                            {
                              "enName": "地图历史总数",
                              "cnName": "地图历史总数",
                              "metricKey": "wow_map_cnt_accum",
                              "rainbowKey": "Pubg wow map cnt accum",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "下架数",
                              "cnName": "下架数",
                              "metricKey": "wow_remove_works_num",
                              "rainbowKey": "Pubg wow remove works num",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "首发作品数",
                              "cnName": "首发作品数",
                              "metricKey": "wow_first_release_cnt",
                              "rainbowKey": "Pubg wow first release cnt",
                              "type": "int",
                              "decimal": 0
                            },
                            {
                              "enName": "编辑次留",
                              "cnName": "编辑次留",
                              "metricKey": "wow_author_d2",
                              "rainbowKey": "Pubg wow author d2",
                              "type": "percent",
                              "decimal": 2
                            },
                            {
                              "enName": "编辑3留",
                              "cnName": "编辑3留",
                              "metricKey": "wow_author_d3",
                              "rainbowKey": "Pubg wow author d3",
                              "type": "percent",
                              "decimal": 2
                            },
                            {
                              "enName": "编辑7留",
                              "cnName": "编辑7留",
                              "metricKey": "wow_author_d7",
                              "rainbowKey": "Pubg wow author d7",
                              "type": "percent",
                              "decimal": 2
                            },
                            {
                              "enName": "编辑30留",
                              "cnName": "编辑30留",
                              "metricKey": "wow_author_d30",
                              "rainbowKey": "Pubg wow author d30",
                              "type": "percent",
                              "decimal": 2
                            }
                          ]
                        }
                      }
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "margin-t-10",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 12
                  },
                  "children": [
                    {
                      "name": "WowNewUserService",
                      "className": "",
                      "type": "view",
                      "props": {
                        "api": "/api/v1/dashboard/wow/metrics_trend",
                        "metrics": [
                          "wow_new_user",
                          "wow_return_user",
                          "wow_retention_user"
                        ]
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "titleEn": "日活用户构成",
                              "titleCn": "日活用户构成",
                              "timeType": "DAY",
                              "metricType": "dau",
                              "customNameMap": {
                                "模式新增用户": "wow_new_user",
                                "模式留存用户": "wow_retention_user",
                                "模式回流用户": "wow_return_user"
                              },
                              "customeAuLegend": [
                                "模式新增用户",
                                "模式留存用户",
                                "模式回流用户"
                              ],
                              "customTableNameMap": {
                                "wow_new_user": "模式新增用户",
                                "wow_retention_user": "模式留存用户",
                                "wow_return_user": "模式回流用户"
                              },
                              "auName": {
                                "enName": "日活跃",
                                "cnName": "日活跃"
                              },
                              "customSumName": {
                                "enName": "日活跃",
                                "cnName": "日活跃"
                              },
                              "auTableWidth": 100
                            }
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 12
                  },
                  "children": [
                    {
                      "name": "WowNewUserChannleService",
                      "className": "",
                      "type": "view",
                      "props": {
                        "api": "/api/v1/dashboard/wow/breakdown",
                        "byType": "channel",
                        "metric": "wow_new_user"
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "titleEn": "模式新增用户渠道构成",
                              "titleCn": "模式新增用户渠道构成",
                              "timeType": "DAY",
                              "metricType": "channel",
                              "metricKey": "channels_of_new_user",
                              "metricTotalKey": "channels_of_new_user_total",
                              "systemName": {
                                "enName": "模式新增用户",
                                "cnName": "模式新增用户"
                              },
                              "customSumName": {
                                "enName": "模式新增用户",
                                "cnName": "模式新增用户"
                              },
                              "systemTableWidth": 100
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "RankListTabCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "data": {
                    "tabOrder": [
                      "wow_player_act_num",
                      "wow_player_new_num",
                      "wow_player_inv_num",
                      "wow_author_act_num",
                      "wow_author_new_num",
                      "wow_author_inv_num"
                    ],
                    "optionsInit": [
                      {
                        "textEn": "游玩-游戏活跃",
                        "textCn": "游玩-游戏活跃",
                        "titleEn": "游玩-游戏活跃国家(TOP10)",
                        "titleCn": "游玩-游戏活跃国家(TOP10)",
                        "value": "wow_player_act_num"
                      },
                      {
                        "textEn": "游玩-游戏新进",
                        "textCn": "游玩-游戏新进",
                        "titleEn": "游玩-游戏新进国家(TOP10)",
                        "titleCn": "游玩-游戏新进国家(TOP10)",
                        "value": "wow_player_new_num"
                      },
                      {
                        "textEn": "游玩-游戏回流",
                        "textCn": "游玩-游戏回流",
                        "titleEn": "游玩-游戏回流国家(TOP10)",
                        "titleCn": "游玩-游戏回流国家(TOP10)",
                        "value": "wow_player_inv_num"
                      },
                      {
                        "textEn": "创作-游戏活跃",
                        "textCn": "创作-游戏活跃",
                        "titleEn": "创作-游戏活跃国家(TOP10)",
                        "titleCn": "创作-游戏活跃国家(TOP10)",
                        "value": "wow_author_act_num"
                      },
                      {
                        "textEn": "创作-游戏新进",
                        "textCn": "创作-游戏新进",
                        "titleEn": "创作-游戏新进国家(TOP10)",
                        "titleCn": "创作-游戏新进国家(TOP10)",
                        "value": "wow_author_new_num"
                      },
                      {
                        "textEn": "创作-游戏回流",
                        "textCn": "创作-游戏回流",
                        "titleEn": "创作-游戏回流国家(TOP10)",
                        "titleCn": "创作-游戏回流国家(TOP10)",
                        "value": "wow_author_inv_num"
                      }
                    ],
                    "regionDataType": "wow_player_act_num",
                    "defaultRegionDataType": "country"
                  },
                  "children": [
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/wow/breakdown",
                          "metric": "wow_player_act_num",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          },
                          "extraColumn": [
                            {
                              "headerEN": "Play Rate",
                              "headerCN": "游玩率",
                              "width": 140,
                              "columnKey": "part_of_all",
                              "columnIndex": 3,
                              "dataFormats": {
                                "wow_player_act_num": "absPercent1Decimal",
                                "wow_player_new_num": "absPercent1Decimal",
                                "wow_player_inv_num": "absPercent1Decimal",
                                "wow_author_act_num": "absPercent1Decimal",
                                "wow_author_new_num": {
                                  "type": "percent",
                                  "decimal": 4
                                },
                                "wow_author_inv_num": {
                                  "type": "percent",
                                  "decimal": 4
                                }
                              },
                              "tabKey": [
                                "wow_player_act_num",
                                "wow_player_new_num",
                                "wow_player_inv_num",
                                "wow_author_act_num",
                                "wow_author_new_num",
                                "wow_author_inv_num"
                              ]
                            }
                          ]
                        }
                      }
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "margin-t-10",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 12
                  },
                  "children": [
                    {
                      "name": "PlayLevelService",
                      "props": {
                        "api": "/api/v1/dashboard/wow/trend_breakdown",
                        "dataKey": "dwm_data_list",
                        "tableFormat": "thousandsInit"
                      },
                      "data": {
                        "metric": "wow_player_ugc_act_num"
                      },
                      "children": [
                        {
                          "name": "CreatorProfile",
                          "type": "view",
                          "className": "overlay-line",
                          "style": {},
                          "props": {
                            "titleEn": "游玩程度",
                            "titleCn": "游玩程度",
                            "defaultActiveTab": 1,
                            "hasSum": true,
                            "options": [
                              {
                                "key": "date",
                                "align": "left",
                                "fixed": "left",
                                "headerEn": "Date",
                                "headerCn": "日期",
                                "width": 160
                              },
                              {
                                "key": "total",
                                "align": "right",
                                "fixed": "left",
                                "width": 160
                              },
                              {
                                "key": "value1",
                                "align": "right",
                                "headerEn": "尝鲜型",
                                "headerCn": "尝鲜型",
                                "width": 140
                              },
                              {
                                "key": "value2",
                                "align": "right",
                                "headerEn": "玩法填充型",
                                "headerCn": "玩法填充型",
                                "width": 140
                              },
                              {
                                "key": "value3",
                                "align": "right",
                                "headerEn": "玩法偏好型",
                                "headerCn": "玩法偏好型",
                                "width": 140
                              }
                            ],
                            "componentSegment": [
                              {
                                "enName": "游戏活跃",
                                "cnName": "游戏活跃",
                                "value": "wow_player_ugc_act_num"
                              },
                              {
                                "enName": "游戏新进",
                                "cnName": "游戏新进",
                                "value": "wow_player_ugc_new_num"
                              },
                              {
                                "enName": "游戏回流",
                                "cnName": "游戏回流",
                                "value": "wow_player_ugc_inv_num"
                              },
                              {
                                "enName": "游戏留存",
                                "cnName": "游戏留存",
                                "value": "wow_player_ugc_rem_num"
                              }
                            ]
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 12
                  },
                  "children": [
                    {
                      "name": "CreatorProfileService",
                      "props": {
                        "api": "/api/v1/dashboard/wow/trend_breakdown",
                        "dataKey": "dwm_data_list",
                        "tableFormat": "thousandsInit",
                        "byType": "competency_active",
                        "metric": "wow_author_1w_active_cnt"
                      },
                      "children": [
                        {
                          "name": "CreatorProfile",
                          "type": "view",
                          "className": "overlay-line",
                          "style": {},
                          "props": {
                            "titleEn": "创作者用户画像（活跃、能力、周期）",
                            "titleCn": "创作者用户画像（活跃、能力、周期）",
                            "defaultActiveTab": 2,
                            "height": 364,
                            "options": [
                              {
                                "key": "date",
                                "align": "left",
                                "fixed": "left",
                                "width": 100,
                                "headerEn": "Date",
                                "headerCn": "日期"
                              },
                              {
                                "key": "name",
                                "align": "right",
                                "fixed": "left",
                                "width": 100,
                                "headerEn": "创作者用户类型",
                                "headerCn": "创作者用户类型"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "fixed": "left",
                                "width": 100,
                                "headerEn": "人数",
                                "headerCn": "人数"
                              }
                            ]
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "WowMapService",
              "props": {
                "api": "/api/v1/dashboard/wow/trend_breakdown",
                "metricsParams": {
                  "key": "wow_map_cnt",
                  "customName": "{{full_crz_name}}星作品地图数"
                }
              },
              "children": [
                {
                  "name": "SegmentCo",
                  "className": "dbd-saleOverview-segment segment-light",
                  "props": {
                    "config": {
                      "dataKey": "metric",
                      "options": [
                        {
                          "name": "地图星级分布",
                          "nameCn": "地图星级分布",
                          "value": "wow_map_cnt",
                          "bubble": "",
                          "bubbleCn": ""
                        },
                        {
                          "name": "地图玩法标签类型数量",
                          "nameCn": "地图玩法标签类型数量",
                          "value": "wow_tag_map_cnt",
                          "bubble": "",
                          "bubbleCn": ""
                        },
                        {
                          "name": "地图玩法标签游玩分布",
                          "nameCn": "地图玩法标签游玩分布",
                          "value": "wow_tag_player_cnt",
                          "bubble": "",
                          "bubbleCn": ""
                        }
                      ]
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 24
                          },
                          "children": [
                            {
                              "name": "SalesBreakdownCardContext",
                              "props": {
                                "config": {
                                  "apiDataKey": "data",
                                  "tabKey": "metric",
                                  "title": [
                                    {
                                      "type": "wow_map_cnt",
                                      "name": "地图星级分布",
                                      "nameCn": "地图星级分布"
                                    },
                                    {
                                      "type": "wow_tag_map_cnt",
                                      "name": "地图玩法标签类型数量",
                                      "nameCn": "地图玩法标签类型数量"
                                    },
                                    {
                                      "type": "wow_tag_player_cnt",
                                      "name": "地图玩法标签游玩分布",
                                      "nameCn": "地图玩法标签游玩分布"
                                    }
                                  ],
                                  "tooltipConfig": {
                                    "valueNameCn": "数量",
                                    "valueNameEn": "数量",
                                    "shareNameCn": "占比",
                                    "shareNameEn": "占比",
                                    "sumNameCn": "汇总",
                                    "sumNameEn": "汇总"
                                  },
                                  "tableDataKey": "dwm_list",
                                  "chartDataKey": "dwm_data_list",
                                  "chart": {
                                    "labelKey": "full_crz_name",
                                    "dateKey": "date_ymd"
                                  },
                                  "table": {
                                    "labelKey": "full_crz_name",
                                    "dateKey": "date_ymd",
                                    "metricWidth": 160
                                  },
                                  "hideConfig": [],
                                  "defaultAvtive": 1,
                                  "dataFormat": "number"
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverviewTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/wow/table_top100",
                    "tableDownloadApi": "/api/v1/dashboard/wow/table_top100/download"
                  },
                  "tableConfig": {
                    "title": {
                      "titleEn": "TOP100作品监控",
                      "titleCn": "TOP100作品监控"
                    },
                    "showDimList": false,
                    "hideMetricsSettings": true,
                    "showTypeOptions": false,
                    "showModalData": false,
                    "showModalDataStat": false,
                    "isCheckAllAccumulated": true
                  },
                  "defaultSort": [
                    {
                      "by": "",
                      "order": "desc"
                    }
                  ],
                  "isSingleDate": false,
                  "cutomColumnsBeforeDim": false,
                  "getParams": "function (params) { return { ...params, accumulation: undefined }}",
                  "customColumns": [
                    {
                      "columnKey": "wow_top_modid",
                      "valueKey": "wow_top_modid",
                      "rainbowKey": "",
                      "nameEn": "作品ID",
                      "nameCn": "作品ID",
                      "enWidth": 150,
                      "cnWidth": 150
                    },
                    {
                      "columnKey": "wow_top_modname",
                      "valueKey": "wow_top_modname",
                      "rainbowKey": "",
                      "nameEn": "作品名称",
                      "nameCn": "作品名称",
                      "enWidth": 200,
                      "cnWidth": 200
                    },
                    {
                      "columnKey": "wow_top_uid",
                      "valueKey": "wow_top_uid",
                      "rainbowKey": "",
                      "nameEn": "创作者UID",
                      "nameCn": "创作者UID",
                      "enWidth": 150,
                      "cnWidth": 150
                    },
                    {
                      "columnKey": "wow_top_vrolename",
                      "valueKey": "wow_top_vrolename",
                      "rainbowKey": "",
                      "nameEn": "创作者昵称",
                      "nameCn": "创作者昵称",
                      "enWidth": 200,
                      "cnWidth": 200
                    }
                  ],
                  "componentMetrics": [
                    {
                      "metricKey": "wow_top_acu",
                      "reqMetricKey": "wow_top_acu",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "平均同时在线",
                      "cnName": "平均同时在线",
                      "rainbowKey": "",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_pcu",
                      "reqMetricKey": "wow_top_pcu",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "最高同时在线",
                      "cnName": "最高同时在线",
                      "rainbowKey": "",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_playercnt",
                      "reqMetricKey": "wow_top_playercnt",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "参与人数",
                      "cnName": "参与人数",
                      "rainbowKey": "",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_participate_rate",
                      "reqMetricKey": "wow_top_participate_rate",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "参与率",
                      "cnName": "参与率",
                      "rainbowKey": "",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_mod_rank",
                      "reqMetricKey": "wow_top_mod_rank",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "参与排名",
                      "cnName": "参与排名",
                      "rainbowKey": "",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_avg_battlecnt",
                      "reqMetricKey": "wow_top_avg_battlecnt",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "人均场次",
                      "cnName": "人均场次",
                      "rainbowKey": "",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_avg_roundtime",
                      "reqMetricKey": "wow_top_avg_roundtime",
                      "enPercentWidth": 150,
                      "cnPercentWidth": 150,
                      "enWidth": 150,
                      "cnWidth": 150,
                      "enName": "场均时长(分钟)",
                      "cnName": "场均时长(分钟)",
                      "rainbowKey": "",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_day2_playercnt",
                      "reqMetricKey": "wow_top_day2_playercnt",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "玩法次留",
                      "cnName": "玩法次留",
                      "rainbowKey": "",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_day3_playercnt",
                      "reqMetricKey": "wow_top_day3_playercnt",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "玩法3留",
                      "cnName": "玩法3留",
                      "rainbowKey": "",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_day7_playercnt",
                      "reqMetricKey": "wow_top_day7_playercnt",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "玩法7留",
                      "cnName": "玩法7留",
                      "rainbowKey": "",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "wow_top_day30_playercnt",
                      "reqMetricKey": "wow_top_day30_playercnt",
                      "enPercentWidth": 120,
                      "cnPercentWidth": 120,
                      "enWidth": 120,
                      "cnWidth": 120,
                      "enName": "玩法30留",
                      "cnName": "玩法30留",
                      "rainbowKey": "",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ]
};